import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconThumbsDown12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.745 7.02a1.5 1.5 0 0 0 1.511-1.5V2.499a1.5 1.5 0 0 0-1.5-1.5h-.5v6.017zm-1.489.66V.998H3.758a1.5 1.5 0 0 0-1.385.926L1.116 4.956a1.5 1.5 0 0 0 1.386 2.075h1.754v2.982c0 .962 1.224 1.37 1.8.6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown12Filled);
